<div class="content holding-card-content" (click)="openContactsModal()">
  <mat-icon svgIcon="add-from-contacts" class="notranslate"></mat-icon>
  <div class="description">
    <h3 class="clickable-title">{{title ? title : 'Add From Contact List'}}</h3>
    <span>{{description ? description : 'Add one or more investors from your contact list.'}}</span>
  </div>
</div>
